<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const { t } = useI18n();
const loading = ref(true);
const report = ref({});
const metricLabels = {
  gross_revenue: 'SALES.GROSS_REVENUE',
  net_revenue: 'SALES.NET_REVENUE',
  fee_revenue: 'SALES.FEE_REVENUE',
  average_ticket: 'SALES.AVERAGE_TICKET',
  count: 'SALES.COUNT',
  refunds: 'SALES.REFUNDS',
  chargebacks: 'SALES.CHARGEBACKS',
};

onMounted(async () => {
  const response = await window.axios.get(
    `/api/v2/accounts/${route.params.accountId}/sales_report`
  );
  report.value = response.data;
  loading.value = false;
});
</script>

<template>
  <main class="p-6">
    <h1 class="mb-6 text-xl font-semibold">{{ t('SALES.REPORT_TITLE') }}</h1>
    <p v-if="loading" class="text-n-500">{{ t('SALES.LOADING') }}</p>
    <div v-else class="grid grid-cols-2 gap-4 md:grid-cols-4">
      <div
        v-for="metric in [
          'gross_revenue',
          'net_revenue',
          'fee_revenue',
          'average_ticket',
          'count',
          'refunds',
          'chargebacks',
        ]"
        :key="metric"
        class="rounded-lg border border-n-weak p-4"
      >
        <p class="text-sm text-n-500">
          {{ t(metricLabels[metric]) }}
        </p>
        <p class="text-xl font-semibold">{{ report[metric] }}</p>
      </div>
    </div>
  </main>
</template>
